export default function ({ $useConfig, $EClientConfig, error, redirect }) {
  if ($useConfig($EClientConfig.ENABLE_BOARD_MODE)) {
    error({ statusCode: 404, message: 'Page not found' })
  }
}
